import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, ChevronDown, ChevronUp } from 'lucide-react';
import { useRecoilValue } from 'recoil';
import { userProfileData } from '../RecoilAtom';

export const ChatSummaryBubble = ({
  summary,
  fullContent,
  icon,
  maxLength = 80,
  onTap
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const userProfile = useRecoilValue(userProfileData);

  const displayContent = fullContent || summary;
  const needsTruncation = displayContent.length > maxLength;
  const truncatedContent = needsTruncation
    ? displayContent.slice(0, maxLength) + '...'
    : displayContent;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{
        type: 'spring',
        stiffness: 350,
        damping: 25
      }}
      className="gm-summary-row"
    >
      <motion.div
        className={`gm-summary-bubble ${onTap ? 'gm-summary-bubble--tappable' : ''}`}
        layout
        onClick={(e) => {
          if (onTap) {
            e.stopPropagation();
            onTap();
          }
        }}
      >
        <div className="gm-summary-body">
          {icon && (
            <div className="gm-summary-icon-row">
              {icon}
            </div>
          )}

          <AnimatePresence mode="wait">
            <motion.p
              key={isExpanded ? 'full' : 'truncated'}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="gm-summary-text"
            >
              {displayContent}
            </motion.p>
          </AnimatePresence>
        </div>
      </motion.div>

      <motion.div
        className="gm-bubble-avatar-user"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: 'spring', delay: 0.1 }}
      >
        {userProfile?.profilePic ? (
          <img
            src={userProfile.profilePic}
            alt="user"
            className="gm-bubble-avatar-img"
          />
        ) : (
          <User className="gm-icon-md gm-text-foreground" />
        )}
      </motion.div>
    </motion.div>
  );
};
